import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import MuiAppbar from "@mui/material/AppBar";

const drawerWidth = 250;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    backgroundColor: "#494949",
    overflowX: 'hidden'
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(8)} + 1px)`,
    backgroundColor: "#494949",
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)}) + 1px`
    }
});


const Drawer = styled( MuiDrawer , { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        // width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    background: "linear-gradient(0deg, rgba(73,73,73,1) 0%, rgba(29,29,29,1) 55%, rgba(52,52,52,1) 100%)",
    zIndex: theme.zIndex.drawer + 10,
    // padding: theme.spacing(0, 1),
    padding: 0,
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
}));

// interface AppBarProps extends MuiAppBarProps {
//     open?: boolean   
// }

const AppBar = styled( MuiAppbar, { shouldForwardProp: ( prop ) => prop !== 'open', }) (
    ({ theme, open }) => ({
    zIndex: theme.zIndex.drawer,
    backgroundColor: "#343434",
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


export { Drawer, DrawerHeader, AppBar }